import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tiebreakScore',
  standalone: false
})
export class TiebreakScorePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
